import type { PriceMode } from './DistributionSection.types'

/**
 * Convert price based on price mode for rentals
 */
export const convertRentalPrice = (
  price: number,
  isRental: boolean,
  priceMode?: PriceMode
): number => {
  if (!isRental || !priceMode || priceMode === 'monthly') return price
  return price * 12
}

/**
 * Format price value for display
 */
export const formatPrice = (
  value: number,
  isRental: boolean,
  priceMode?: PriceMode
): string => {
  const displayValue = convertRentalPrice(value, isRental, priceMode)

  if (isRental) {
    if (displayValue >= 10000) return `${(displayValue / 1000).toFixed(0)}k`
    if (displayValue >= 1000) return `${(displayValue / 1000).toFixed(1)}k`
    return `${displayValue.toFixed(0)}`
  }
  if (displayValue >= 1000000) return `${(displayValue / 1000000).toFixed(1)}M`
  if (displayValue >= 1000) return `${(displayValue / 1000).toFixed(0)}k`
  return `${displayValue.toFixed(0)}`
}

/**
 * Format area value for display
 */
export const formatArea = (value: number): string => {
  return `${value.toFixed(0)}`
}

/**
 * Format rooms value for display
 */
export const formatRooms = (value: number): string => {
  if (value <= 1.5) return '≤1.5'
  if (value >= 7) return '7+'
  return `${value - 0.5}-${value}`
}
